export default __webpack_public_path__ + "static/Logo Placement – Hilux – 1280px-d2cc6d0daf30e78fe8d1d8ae00d0b03d.png";